// import randomAngle from "../helpers/randomAngle";

export default function samePin(movePath, handleFinalTouchAngle, _spin) {
  let touch, next;
  let spin = (_spin || 6) / 2;

  let checkedSpin;
  if (spin > 3) {
    checkedSpin = 3;
  } else if (spin < 2) {
    checkedSpin = 2;
  } else {
    checkedSpin = spin;
  }
  // min - 0 | max - 6
  next = movePath[0]; // 1 - right, 0 - left
  //   let afterNext = movePath[1]; // 1 - right, 0 - left: ;
  //   next === "1" ? (column = _column + 1) : (column = _column - 1);
  //   movePath[0] = next === "1" ? "0" : "1";
  let finalAngle = next === "1" ? 70 : 130;

  let time = 250 + checkedSpin * 50;
  touch = handleFinalTouchAngle(finalAngle);
  return [touch, checkedSpin, time, movePath, finalAngle];
}
